import { AuthError, type AuthErrorCode } from '@volee/auth'

import { EN_AUTH_ERRORS } from './en/auth-errors.ts'
import { IT_AUTH_ERRORS } from './it/auth-errors.ts'
import { locale } from './locale.ts'
import { errorMessage } from './from-error.ts'

/** The catalogue of the active language. `AuthError.message` is English, for logs only. */
export const AUTH_ERRORS: Record<AuthErrorCode, string> =
  locale === 'en' ? EN_AUTH_ERRORS : IT_AUTH_ERRORS

// Delegates everything that is not an AuthError, so "no connection" still arrives.
export function authErrorMessage(error: unknown): string {
  return error instanceof AuthError ? AUTH_ERRORS[error.code] : errorMessage(error)
}
